/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */
import digest from 'core/digest';

export const sandboxLocalResponsePersistenceStrategy = 'sandbox-local-response';

/**
 * Sandbox/manual testing persists the recording as a lightweight local response.
 * The real runner path now uses the generic attachment upload service instead.
 * @param {Object} root0
 * @param {File} root0.file
 * @param {String} root0.itemIdentifier
 * @param {String} root0.responseIdentifier
 * @param {Number} root0.recordingDurationMs
 * @param {String} root0.recorderMimeType
 * @param {String} root0.localPreviewUrl
 * @returns {Promise<Object>}
 */
export function createSandboxVideoRecordingResponse({
    file,
    itemIdentifier,
    responseIdentifier,
    recordingDurationMs,
    recorderMimeType,
    localPreviewUrl
}) {
    return digest(file, 'SHA-256').then(fileHash => ({
        message: 'Sandbox/manual mode keeps this recording local to the current browser session.',
        responseValue: {
            data: fileHash,
            name: file.name,
            mime: file.type,
            id: `${itemIdentifier}/${responseIdentifier}/sandbox-video-recording`,
            version: null,
            downloadUrl: localPreviewUrl,
            sizeBytes: file.size,
            durationMs: recordingDurationMs,
            recorderMimeType,
            persistenceStrategy: sandboxLocalResponsePersistenceStrategy
        }
    }));
}
